import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import PanelTemplate from '../../common/PanelTemplate';
import { AccountList } from 'enlm_ui_common';
import I18n from '../../../config/locales';

import { connect } from 'react-redux';
import { TRAINING_DASHBOARD_LINK_IDENTIFIER } from '../../../containers/TrainingDashboard/constants';
import { forwardTo } from '../../../utils/helper';

const useStyles = makeStyles(theme => ({
  scoreCardBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2.5, 3.75)
  }
}));

const AccountDetails = props => {
  const {
    companyId,
    accountList,
    state,
    abLreEnabled,
    abPermitEnabled,
    abBOMEnabled,
    abSgipEnabled,
    abEinMerchandise,
    enlightenManagerToken,
    einOptIn,
    hasTier,
    leadOptIn,
    belongsToIt,
    viewOnlyAccess,
    companyInfo,
    dashboardLinks,
    accountData,
    einOptOut,
    countryCode,
    belongsToBr,
    pathName,
    searchParam = '',
    trainingDashboardToken,
    featureList,
    isAuthorizedSubcontractor,
    generatorTokensEnabled,
    dataPlanExtensionEnabled
    // showBomDialog = () => {}
  } = props;

  const { title, list } = accountList;
  const ifTrainingDashboardWhetherDisplay = name =>
    name !== TRAINING_DASHBOARD_LINK_IDENTIFIER || trainingDashboardToken;
  const notDisplayServices = (belongsToBr || belongsToIt) && title === 'services';
  const classes = useStyles();
  if (!notDisplayServices) {
    return (
      <PanelTemplate header={I18n.t(`accountInfo.${title}`)} boxShadow id={title}>
        <Box className={classes.scoreCardBody}>
          {list.map(
            (account, index) =>
              ifTrainingDashboardWhetherDisplay(account.name) && (
                <AccountList
                  key={index}
                  companyId={companyId}
                  accountList={account}
                  accountData={accountData}
                  leadOptIn={leadOptIn}
                  abLreEnabled={abLreEnabled}
                  abSgipEnabled={abSgipEnabled}
                  abPermitEnabled={abPermitEnabled}
                  abBOMEnabled={abBOMEnabled}
                  abEinMerchandise={abEinMerchandise}
                  state={state}
                  title={title}
                  enlightenManagerToken={enlightenManagerToken}
                  einOptIn={einOptIn}
                  einOptOut={einOptOut}
                  hasTier={hasTier}
                  pathName={pathName}
                  searchParam={searchParam}
                  countryCode={countryCode}
                  viewOnlyAccess={viewOnlyAccess}
                  companyInfo={companyInfo}
                  dashboardLinks={dashboardLinks}
                  forwardTo={forwardTo}
                  featureList={featureList}
                  isAuthorizedSubcontractor={isAuthorizedSubcontractor}
                  generatorTokensEnabled={generatorTokensEnabled}
                  dataPlanExtensionEnabled={dataPlanExtensionEnabled}
                  // showBomDialog={showBomDialog}
                />
              )
          )}
        </Box>
      </PanelTemplate>
    );
  } else {
    return null;
  }
};

const mapStateToProps = state => ({
  belongsToIt: state.appReducer.belongsToIt,
  belongsToBr: state.appReducer.belongsToBr,
  trainingDashboardToken: state.accountReducer.trainingDashboardToken,
  featureList: state.appReducer.featureList
});

export default connect(mapStateToProps)(AccountDetails);
